module.exports = __webpack_public_path__ + "img/jslogo.d0e8fd7c.png";